// extracted by mini-css-extract-plugin
module.exports = {"container":"AppLoader_container__mhpzD","ball":"AppLoader_ball__Nf5pW","slide":"AppLoader_slide__QA4oQ"};